module.exports = __webpack_public_path__ + "img/blingblingsquare.3a801950.gif";